import React, { useState, useEffect } from 'react';
import styles from './CargaConsumoCombustible.module.css';

const API_URL = 'https://appcorp.parma.com.gt/apipp/ReceptorDatos';
const TOKEN = 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY';

const getValue = (row, ...keys) => {
  for (const key of keys) {
    if (row && Object.prototype.hasOwnProperty.call(row, key)) return row[key];
  }
  return undefined;
};

const toNumber = (value) => {
  if (value === null || value === undefined || value === '' || value === 'NaN') return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

const getFechaEmision = (row) =>
  getValue(row, 'Fecha emisión', 'Fecha emision', 'Fecha emisiÃ³n', 'Fecha emisiÃƒÂ³n');

const getDiaEmision = (row) => {
  const value = getFechaEmision(row);
  if (!value) return null;

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return value.toISOString().split('T')[0];
  }

  const text = String(value).trim();
  const matchDMY = text.match(/^(\d{2})-(\d{2})-(\d{4})/);
  if (matchDMY) {
    const [, day, month, year] = matchDMY;
    return `${year}-${month}-${day}`;
  }

  const matchYMD = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (matchYMD) return matchYMD[0];

  return text.split(' ')[0] || null;
};

const normalizeRow = (row) => ({
  ...row,
  'Fecha emisión': getValue(row, 'Fecha emisión', 'Fecha emision', 'Fecha emisiÃ³n'),
  'Código establecimiento': toNumber(getValue(row, 'Código establecimiento', 'Codigo establecimiento', 'CÃ³digo establecimiento')),
  'Código producto': getValue(row, 'Código producto', 'Codigo producto', 'CÃ³digo producto'),
  'Número cupón': getValue(row, 'Número cupón', 'Numero cupon', 'NÃºmero cupÃ³n'),
  'Monto descuento cupón': toNumber(getValue(row, 'Monto descuento cupón', 'Monto descuento cupon', 'Monto descuento cupÃ³n')),
  'Total venta': toNumber(row['Total venta']) || 0,
  'IVA Total': toNumber(row['IVA Total']) || 0,
  'IDP Total': toNumber(row['IDP Total']) || 0,
  Cantidad: toNumber(row.Cantidad) || 0,
  'Precio Unitario': toNumber(row['Precio Unitario']) || 0,
  'Total detalle': toNumber(row['Total detalle']) || 0,
  'IVA Detalle': toNumber(row['IVA Detalle']),
  'IDP Detalle': toNumber(row['IDP Detalle']),
  'Total descuento realizado': toNumber(row['Total descuento realizado']) || 0,
  'Otro descuento': toNumber(row['Otro descuento']) || 0
});

const parseApiResponse = (response) => {
  console.group('[CargaArchivoGastore] Parse respuesta API');
  console.log('Respuesta recibida para parsear:', response);

  if (!response) return [];

  const generated =
    response?.Metodo?.Datos_Generados ||
    response?.metodo?.datos_Generados ||
    response?.datos_Generados ||
    response?.Datos_Generados;

  console.log('Datos_Generados detectado:', generated);

  if (!generated) {
    console.warn('Datos_Generados viene vacio o no existe en la respuesta del API.');
    console.groupEnd();
    return [];
  }

  try {
    const parsed = typeof generated === 'string' ? JSON.parse(generated) : generated;
    console.log('Datos_Generados parseado:', parsed);
    console.groupEnd();
    return Array.isArray(parsed?.RESP) ? parsed.RESP : [];
  } catch (error) {
    console.error('Error parseando Datos_Generados:', error);
    console.groupEnd();
    return [];
  }
};

const enviarArchivoGastore = async ({ fileName, fileDate, data }) => {
  const datosRecibidos = {
    Tabla: 'fd_fact_gas',
    TipoOperacion: 'Insert',
    NombreArchivo: fileName,
    FechaInformacion: fileDate,
    FechaCarga: new Date().toISOString(),
    JsonDetalle: Array.isArray(data) ? data : []
  };

  console.group('[CargaArchivoGastore] Datos antes de enviar');
  console.log('Nombre archivo:', fileName);
  console.log('Fecha informacion:', fileDate);
  console.log('Cantidad registros detalle:', Array.isArray(data) ? data.length : 0);
  console.log('Primer registro detalle:', Array.isArray(data) ? data[0] : null);
  console.log('Objeto Datos_Recibidos sin stringify:', datosRecibidos);
  console.log('JsonDetalle es arreglo:', Array.isArray(datosRecibidos.JsonDetalle));
  console.groupEnd();

  const payload = {
    Token: TOKEN,
    Ambiente: 'DESA',
    Dispositivo: {
      Marca: 'WEB',
      Modelo: 'React',
      Version: '1.0',
      McAdress: null,
      PowerStatus: '100%',
      WifiStatus: 'Connected',
      GPSStatus: 'OFF',
      GPS: ''
    },
    User: {
      Codigo: '0',
      UserNickName: 'pierril'
    },
    Metodo: {
      NombreMetodo: 'CargaArchivoGastore',
      Datos_Recibidos: JSON.stringify(datosRecibidos),
      Datos_Generados: ''
    }
  };

  console.group('[CargaArchivoGastore] Request API');
  console.log('URL:', API_URL);
  console.log('Metodo HTTP:', 'POST');
  console.log('Headers:', { 'Content-Type': 'application/json' });
  console.log('Payload completo:', payload);
  console.log('Metodo.Datos_Recibidos string:', payload.Metodo.Datos_Recibidos);
  console.log('Body final enviado:', JSON.stringify(payload));
  console.groupEnd();

  const response = await fetch(API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  });

  const text = await response.text();

  console.group('[CargaArchivoGastore] Response API');
  console.log('HTTP status:', response.status);
  console.log('HTTP ok:', response.ok);
  console.log('Response headers:', Object.fromEntries(response.headers.entries()));
  console.log('Texto crudo respuesta:', text);
  console.groupEnd();

  if (!response.ok) {
    throw new Error(`Error HTTP ${response.status}: ${text}`);
  }

  try {
    const json = JSON.parse(text);
    console.group('[CargaArchivoGastore] Response API parseada');
    console.log('JSON parseado:', json);
    console.log('nombreMetodo:', json?.nombreMetodo || json?.NombreMetodo);
    console.log('datos_Recibidos:', json?.datos_Recibidos || json?.Datos_Recibidos);
    console.log('datos_Generados:', json?.datos_Generados || json?.Datos_Generados);
    console.log('mensaje:', json?.mensaje || json?.Mensaje);
    console.groupEnd();
    return json;
  } catch (error) {
    console.error('[CargaArchivoGastore] La respuesta no es JSON valido:', error);
    return text;
  }
};

const FileUpload = ({ onFileUpload }) => {
  const [file, setFile] = useState(null);
  const [previewData, setPreviewData] = useState([]);
  const [previewSummary, setPreviewSummary] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [uploadResult, setUploadResult] = useState(null);

  const loadXLSX = () => import('xlsx');

  const extractDateFromFilename = (filename) => {
    const match = filename.match(/(\d{2}-\d{2}-\d{4})/);
    if (match) {
      const [day, month, year] = match[1].split('-');
      return `${year}-${month}-${day}`;
    }
    return new Date().toISOString().split('T')[0];
  };

  const calculateSummary = (data) => {
    const rows = Array.isArray(data) ? data : [];
    const diasArchivo = [...new Set(rows.map(getDiaEmision).filter(Boolean))];
    const esArchivoMultiDia = diasArchivo.length > 1;

    if (esArchivoMultiDia) {
      return {
        totalVentas: null,
        totalIVA: null,
        totalIDP: null,
        totalRegistros: rows.length,
        productos: {},
        tiposPago: {},
        diasArchivo,
        esArchivoMultiDia
      };
    }

    const totalVentas = rows.reduce((sum, row) => sum + (row['Total venta'] || 0), 0);
    const totalIVA = rows.reduce((sum, row) => sum + (row['IVA Total'] || 0), 0);
    const totalIDP = rows.reduce((sum, row) => sum + (row['IDP Total'] || 0), 0);
    const productos = {};
    const tiposPago = {};

    rows.forEach((row) => {
      const producto = row.Producto;
      if (producto) productos[producto] = (productos[producto] || 0) + (row['Total venta'] || 0);

      const tipoPago = row['Tipo pago'];
      if (tipoPago) tiposPago[tipoPago] = (tiposPago[tipoPago] || 0) + (row['Total venta'] || 0);
    });

    return {
      totalVentas,
      totalIVA,
      totalIDP,
      totalRegistros: rows.length,
      productos,
      tiposPago,
      diasArchivo,
      esArchivoMultiDia
    };
  };

  const processFile = async (selectedFile) => {
    setLoading(true);
    setError(null);
    setUploadResult(null);

    try {
      const XLSX = await loadXLSX();
      const data = await selectedFile.arrayBuffer();
      const workbook = XLSX.read(data);
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });
      const processedData = jsonData.map(normalizeRow);
      const summary = calculateSummary(processedData);
      const fileDate = extractDateFromFilename(selectedFile.name);

      setPreviewData(processedData);
      setPreviewSummary(summary);

      return { processedData, summary, fileDate };
    } catch (err) {
      setError('Error al procesar el archivo: ' + err.message);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = async (e) => {
    const selectedFile = e.target.files?.[0];
    if (!selectedFile) return;

    if (!selectedFile.name.match(/\.(xlsx|xls)$/i)) {
      setError('Solo se permiten archivos Excel (.xlsx, .xls)');
      return;
    }

    setFile(selectedFile);
    await processFile(selectedFile);
  };

  const handleUpload = async () => {
    if (!file) {
      setError('Por favor seleccione un archivo');
      return;
    }

    setLoading(true);
    const result = await processFile(file);

    if (result) {
      try {
        const resultUpload = await onFileUpload({
          fileName: file.name,
          fileDate: result.fileDate,
          data: result.processedData,
          summary: result.summary
        });

        setFile(null);
        setPreviewData([]);
        setPreviewSummary(null);
        setUploadResult(resultUpload || null);

        const fileInput = document.getElementById('file-input');
        if (fileInput) fileInput.value = '';

        const registrosInsertados = resultUpload?.registrosInsertados ?? resultUpload?.registrosRecibidos ?? result.processedData.length;
        alert(`Archivo cargado exitosamente. Registros insertados: ${registrosInsertados}`);
      } catch (err) {
        setError('Error al enviar el archivo a la API: ' + err.message);
      }
    }

    setLoading(false);
  };

  const previewRows = Array.isArray(previewData) ? previewData.slice(0, 10) : [];

  return (
    <div className={styles.fileUpload}>
      <h2>Cargar Archivo de Ventas</h2>

      <div className={styles.uploadArea}>
        <input
          type="file"
          accept=".xlsx,.xls"
          onChange={handleFileChange}
          className={styles.fileInput}
          id="file-input"
        />
        <label htmlFor="file-input" className={styles.fileLabel}>
          Seleccionar archivo Excel
        </label>
        {file && (
          <div className={styles.fileInfo}>
            <p>{file.name}</p>
            <p>Fecha extraida: {extractDateFromFilename(file.name)}</p>
            <p>Tamano: {(file.size / 1024).toFixed(2)} KB</p>
          </div>
        )}
      </div>

      {error && <div className={styles.errorMessage}>{error}</div>}

      {uploadResult && (
        <div className={styles.summaryPreview}>
          <h4>Archivo cargado</h4>
          <div className={styles.summaryGrid}>
            <div className={styles.summaryItem}>
              <span>Registros recibidos:</span>
              <strong>{uploadResult.registrosRecibidos ?? 0}</strong>
            </div>
            <div className={styles.summaryItem}>
              <span>Registros insertados:</span>
              <strong>{uploadResult.registrosInsertados ?? 0}</strong>
            </div>
            <div className={styles.summaryItem}>
              <span>Registros duplicados:</span>
              <strong>{uploadResult.registrosDuplicados ?? 0}</strong>
            </div>
            <div className={styles.summaryItem}>
              <span>Dias detectados:</span>
              <strong>{uploadResult.diasArchivo?.length || 0}</strong>
            </div>
          </div>
        </div>
      )}

      {previewSummary && (
        <div className={styles.previewSection}>
          <h3>Vista Previa del Archivo</h3>

          <div className={styles.summaryPreview}>
            <h4>{previewSummary.esArchivoMultiDia ? 'Archivo con varios dias' : 'Resumen General'}</h4>
            <div className={styles.summaryGrid}>
              {!previewSummary.esArchivoMultiDia && (
                <>
                  <div className={styles.summaryItem}>
                    <span>Total Ventas:</span>
                    <strong>Q {previewSummary.totalVentas.toFixed(2)}</strong>
                  </div>
                  <div className={styles.summaryItem}>
                    <span>Total IVA:</span>
                    <strong>Q {previewSummary.totalIVA.toFixed(2)}</strong>
                  </div>
                  <div className={styles.summaryItem}>
                    <span>Total IDP:</span>
                    <strong>Q {previewSummary.totalIDP.toFixed(2)}</strong>
                  </div>
                </>
              )}
              <div className={styles.summaryItem}>
                <span>Total Registros:</span>
                <strong>{previewSummary.totalRegistros}</strong>
              </div>
              {previewSummary.esArchivoMultiDia && (
                <div className={styles.summaryItem}>
                  <span>Dias detectados:</span>
                  <strong>{previewSummary.diasArchivo.length}</strong>
                </div>
              )}
            </div>

            {!previewSummary.esArchivoMultiDia && (
              <div className={styles.productosPreview}>
                <h4>Ventas por Producto</h4>
                <ul>
                  {Object.entries(previewSummary.productos || {}).map(([producto, total]) => (
                    <li key={producto}>
                      {producto}: Q {total.toFixed(2)}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>

          <div className={styles.dataPreview}>
            <div className={styles.tableWrapper}>
              <table className={styles.previewTable}>
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Cliente</th>
                    <th>Producto</th>
                    <th>Cantidad</th>
                    {!previewSummary.esArchivoMultiDia && <th>Total</th>}
                  </tr>
                </thead>
                <tbody>
                  {previewRows.map((row, idx) => (
                    <tr key={idx}>
                      <td>{row['Fecha emisión']}</td>
                      <td>{row.Nombre}</td>
                      <td>{row.Producto}</td>
                      <td>{row.Cantidad}</td>
                      {!previewSummary.esArchivoMultiDia && <td>Q {(row['Total venta'] || 0).toFixed(2)}</td>}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <button
            className={styles.uploadBtn}
            onClick={handleUpload}
            disabled={loading}
          >
            {loading ? 'Procesando...' : 'Confirmar y Guardar Archivo'}
          </button>
        </div>
      )}
    </div>
  );
};

const FileList = ({ files, onViewFile, onDeleteFile }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('date');
  const safeFiles = Array.isArray(files) ? files : [];

  const filteredFiles = safeFiles.filter((file) =>
    (file.name || '').toLowerCase().includes(searchTerm.toLowerCase())
  );

  const sortedFiles = [...filteredFiles].sort((a, b) => {
    if (sortBy === 'date') return new Date(b.date) - new Date(a.date);
    if (sortBy === 'upload') return new Date(b.uploadDate) - new Date(a.uploadDate);
    if (sortBy === 'total') return (b.totalVentas || 0) - (a.totalVentas || 0);
    return 0;
  });

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return Number.isNaN(date.getTime()) ? dateString : date.toLocaleDateString('es-ES');
  };

  return (
    <div className={styles.fileList}>
      <div className={styles.fileListHeader}>
        <h2>Archivos Cargados</h2>
        <div className={styles.controls}>
          <input
            type="text"
            placeholder="Buscar archivo..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className={styles.searchInput}
          />
          <select value={sortBy} onChange={(e) => setSortBy(e.target.value)} className={styles.sortSelect}>
            <option value="date">Ordenar por Fecha Informacion</option>
            <option value="upload">Ordenar por Fecha Carga</option>
            <option value="total">Ordenar por Total Ventas</option>
          </select>
        </div>
      </div>

      {sortedFiles.length === 0 ? (
        <div className={styles.emptyState}>
          <p>No hay archivos cargados</p>
          <p>Usa la pestana "Cargar Archivo" para comenzar</p>
        </div>
      ) : (
        <div className={styles.filesGrid}>
          {sortedFiles.map((file) => (
            <div key={file.id} className={styles.fileCard}>
              <div className={styles.fileCardHeader}>
                <span className={styles.fileIcon}>Archivo</span>
                <h3>{file.name}</h3>
              </div>

              <div className={styles.fileInfo}>
                <p><strong>Fecha Informacion:</strong> {file.date}</p>
                <p><strong>Fecha Carga:</strong> {formatDate(file.uploadDate)}</p>
                {file.summary?.esArchivoMultiDia ? (
                  <>
                    <p><strong>Registros recibidos:</strong> {file.registrosRecibidos ?? (file.data || []).length}</p>
                    <p><strong>Registros insertados:</strong> {file.registrosInsertados ?? 0}</p>
                    <p><strong>Registros duplicados:</strong> {file.registrosDuplicados ?? 0}</p>
                  </>
                ) : (
                  <>
                    <p><strong>Total Ventas:</strong> Q {(file.totalVentas || 0).toFixed(2)}</p>
                    <p><strong>Registros:</strong> {(file.data || []).length}</p>
                    <p><strong>IVA Total:</strong> Q {(file.totalIVA || 0).toFixed(2)}</p>
                    <p><strong>IDP Total:</strong> Q {(file.totalIDP || 0).toFixed(2)}</p>
                  </>
                )}
              </div>

              {!file.summary?.esArchivoMultiDia && (
                <div className={styles.productSummary}>
                  <strong>Productos:</strong>
                  <div className={styles.productTags}>
                    {Object.entries(file.summary?.productos || {}).map(([producto, total]) => (
                      <span key={producto} className={styles.productTag}>
                        {producto}: Q {total.toFixed(2)}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              <div className={styles.fileActions}>
                <button className={styles.viewBtn} onClick={() => onViewFile(file)}>
                  Ver Detalle
                </button>
                <button className={styles.deleteBtn} onClick={() => onDeleteFile(file.id)}>
                  Eliminar
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const DataViewer = ({ data, fileInfo }) => {
  const rows = Array.isArray(data) ? data : [];
  const [filter, setFilter] = useState('');
  const [filteredData, setFilteredData] = useState(rows);

  useEffect(() => {
    setFilteredData(rows);
  }, [data]);

  const handleFilter = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    setFilter(searchTerm);
    setFilteredData(
      rows.filter((row) =>
        row.Nombre?.toLowerCase().includes(searchTerm) ||
        row.Producto?.toLowerCase().includes(searchTerm) ||
        row['Tipo documento']?.toLowerCase().includes(searchTerm)
      )
    );
  };

  const summary = {
    totalVentas: filteredData.reduce((sum, row) => sum + (row['Total venta'] || 0), 0).toFixed(2),
    totalIVA: filteredData.reduce((sum, row) => sum + (row['IVA Total'] || 0), 0).toFixed(2),
    totalIDP: filteredData.reduce((sum, row) => sum + (row['IDP Total'] || 0), 0).toFixed(2),
    totalTransacciones: filteredData.length
  };
  const esArchivoMultiDia = Boolean(fileInfo?.summary?.esArchivoMultiDia);

  return (
    <div className={styles.dataViewer}>
      <div className={styles.fileInfoHeader}>
        <h2>{fileInfo.name}</h2>
        <p>Fecha de informacion: {fileInfo.date}</p>
        <p>Cargado: {new Date(fileInfo.uploadDate).toLocaleString()}</p>
      </div>

      {esArchivoMultiDia ? (
        <div className={styles.summaryCards}>
          <div className={styles.card}>
            <h3>Registros insertados</h3>
            <p className={styles.amount}>{fileInfo.registrosInsertados ?? summary.totalTransacciones}</p>
          </div>
          <div className={styles.card}>
            <h3>Registros recibidos</h3>
            <p className={styles.amount}>{fileInfo.registrosRecibidos ?? rows.length}</p>
          </div>
          <div className={styles.card}>
            <h3>Registros duplicados</h3>
            <p className={styles.amount}>{fileInfo.registrosDuplicados ?? 0}</p>
          </div>
          <div className={styles.card}>
            <h3>Dias detectados</h3>
            <p className={styles.amount}>{fileInfo.diasArchivo?.length || 0}</p>
          </div>
        </div>
      ) : (
        <div className={styles.summaryCards}>
          <div className={styles.card}>
            <h3>Total Ventas</h3>
            <p className={styles.amount}>Q {summary.totalVentas}</p>
          </div>
          <div className={styles.card}>
            <h3>Total IVA</h3>
            <p className={styles.amount}>Q {summary.totalIVA}</p>
          </div>
          <div className={styles.card}>
            <h3>Total IDP</h3>
            <p className={styles.amount}>Q {summary.totalIDP}</p>
          </div>
          <div className={styles.card}>
            <h3>Transacciones</h3>
            <p className={styles.amount}>{summary.totalTransacciones}</p>
          </div>
        </div>
      )}

      <div className={styles.filterSection}>
        <input
          type="text"
          placeholder="Buscar por cliente o producto..."
          value={filter}
          onChange={handleFilter}
          className={styles.filterInput}
        />
      </div>

      <div className={styles.tableContainer}>
        <table className={styles.dataTable}>
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Tipo Doc.</th>
              <th>No. Documento</th>
              <th>NIT</th>
              <th>Nombre</th>
              <th>Producto</th>
              <th>Cantidad</th>
              <th>Precio Unit.</th>
              <th>Total Venta</th>
              <th>IVA</th>
              <th>IDP</th>
              <th>Forma Pago</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((row, idx) => (
              <tr key={idx}>
                <td>{row['Fecha emisión']}</td>
                <td>{row['Tipo documento']}</td>
                <td>{row['No. documento']}</td>
                <td>{row.NIT}</td>
                <td>{row.Nombre}</td>
                <td>{row.Producto}</td>
                <td>{row.Cantidad}</td>
                <td>Q {(row['Precio Unitario'] || 0).toFixed(2)}</td>
                <td>Q {(row['Total venta'] || 0).toFixed(2)}</td>
                <td>Q {(row['IVA Total'] || 0).toFixed(2)}</td>
                <td>Q {(row['IDP Total'] || 0).toFixed(2)}</td>
                <td>{row['Tipo pago']}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const CargaConsumoCombustible = () => {
  const [activeTab, setActiveTab] = useState('upload');
  const [salesData, setSalesData] = useState([]);
  const [currentFileInfo, setCurrentFileInfo] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState(() => {
    try {
      const saved = localStorage.getItem('combustibleFiles');
      const parsed = saved ? JSON.parse(saved) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem('combustibleFiles', JSON.stringify(uploadedFiles));
  }, [uploadedFiles]);

  const handleFileUpload = async (fileData) => {
    console.group('[CargaConsumoCombustible] handleFileUpload');
    console.log('fileData recibido:', fileData);
    console.log('Registros a enviar:', Array.isArray(fileData?.data) ? fileData.data.length : 0);
    console.log('Resumen a enviar:', fileData?.summary);
    console.groupEnd();

    const respuestaApi = await enviarArchivoGastore({
      fileName: fileData.fileName,
      fileDate: fileData.fileDate,
      data: fileData.data
    });

    console.group('[CargaConsumoCombustible] Resultado CargaArchivoGastore');
    console.log('Respuesta completa:', respuestaApi);
    console.log('datos_Recibidos devuelto por API:', respuestaApi?.datos_Recibidos || respuestaApi?.Datos_Recibidos);
    console.log('datos_Generados devuelto por API:', respuestaApi?.datos_Generados || respuestaApi?.Datos_Generados);
    console.log('mensaje devuelto por API:', respuestaApi?.mensaje || respuestaApi?.Mensaje);
    console.groupEnd();

    const resp = parseApiResponse(respuestaApi);
    console.log('[CargaConsumoCombustible] RESP parseado desde SQL/API:', resp);

    const sqlResult = resp[0] || {};
    const sqlMessage = sqlResult.Mensaje;
    if (sqlMessage) {
      throw new Error(sqlMessage);
    }

    const registrosRecibidos = sqlResult.RegistrosRecibidos ?? (Array.isArray(fileData.data) ? fileData.data.length : 0);
    const registrosInsertados = sqlResult.RegistrosInsertados ?? registrosRecibidos;
    const registrosDuplicados = sqlResult.RegistrosDuplicados ?? Math.max(registrosRecibidos - registrosInsertados, 0);

    const newFile = {
      id: Date.now(),
      name: fileData.fileName,
      date: fileData.fileDate,
      uploadDate: new Date().toISOString(),
      data: Array.isArray(fileData.data) ? fileData.data : [],
      summary: fileData.summary,
      totalVentas: fileData.summary?.totalVentas,
      totalIVA: fileData.summary?.totalIVA,
      totalIDP: fileData.summary?.totalIDP,
      registrosRecibidos,
      registrosInsertados,
      registrosDuplicados,
      diasArchivo: fileData.summary?.diasArchivo || [],
      respuestaApi
    };

    setUploadedFiles((prev) => [newFile, ...(Array.isArray(prev) ? prev : [])]);
    return newFile;
  };

  const handleViewFile = (file) => {
    setSalesData(Array.isArray(file.data) ? file.data : []);
    setCurrentFileInfo(file);
    setActiveTab('view');
  };

  const handleDeleteFile = (fileId) => {
    if (window.confirm('Esta seguro de eliminar este archivo?')) {
      setUploadedFiles((prev) => (Array.isArray(prev) ? prev.filter((f) => f.id !== fileId) : []));
    }
  };

  const handleBackToFiles = () => {
    setActiveTab('files');
    setSalesData([]);
    setCurrentFileInfo(null);
  };

  const safeUploadedFiles = Array.isArray(uploadedFiles) ? uploadedFiles : [];

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div className={styles.headerContent}>
          <h1>
            <span className={styles.icon}>Gas</span>
            CargaConsumoCombustible
          </h1>
          <p className={styles.subtitle}>Sistema de gestion de ventas de combustible</p>
        </div>
      </header>

      <div className={styles.tabsContainer}>
        <button
          className={`${styles.tabBtn} ${activeTab === 'upload' ? styles.tabBtnActive : ''}`}
          onClick={() => setActiveTab('upload')}
        >
          Cargar Archivo
        </button>
        <button
          className={`${styles.tabBtn} ${activeTab === 'files' ? styles.tabBtnActive : ''}`}
          onClick={() => setActiveTab('files')}
        >
          Archivos Cargados ({safeUploadedFiles.length})
        </button>
      </div>

      <main className={styles.mainContent}>
        {activeTab === 'upload' && (
          <FileUpload onFileUpload={handleFileUpload} />
        )}

        {activeTab === 'files' && (
          <FileList
            files={safeUploadedFiles}
            onViewFile={handleViewFile}
            onDeleteFile={handleDeleteFile}
          />
        )}

        {activeTab === 'view' && salesData.length > 0 && currentFileInfo && (
          <div>
            <button className={styles.backBtn} onClick={handleBackToFiles}>
              Volver a Archivos
            </button>
            <DataViewer data={salesData} fileInfo={currentFileInfo} />
          </div>
        )}
      </main>
    </div>
  );
};

export default CargaConsumoCombustible;
